import React from 'react';
import PropTypes from 'prop-types';

const DEFAULT_ICON_SIZE = 24;

const sizePropType = PropTypes.oneOfType([PropTypes.number, PropTypes.string]);

function AircraftIcon({ w, h, className }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={w}
      height={h}
      viewBox="0 0 24 24"
      className={className}
    >
      <path d="M18.12 4.85c.572-.572 1.478-.59 2.05-.019.57.571.552 1.478-.02 2.05l-3.608 3.609 1.792 8.452c.1.476-.046.97-.39 1.313l-.719.72-3.779-7.39-3.869 3.869.42 2.18a.722.722 0 01-.198.644l-.762.762-1.765-3.312-3.312-1.764.762-.763a.72.72 0 01.644-.197l2.18.42L18.12 4.849zM4.026 7.775l.739-.739c.343-.343.837-.49 1.312-.39l7.021 1.486-2.828 2.828-6.244-3.185z" />
    </svg>
  );
}

AircraftIcon.ICON_SIZE = DEFAULT_ICON_SIZE;

AircraftIcon.propTypes = {
  w: sizePropType,
  h: sizePropType,
};

AircraftIcon.defaultProps = {
  w: DEFAULT_ICON_SIZE,
  h: DEFAULT_ICON_SIZE,
};

export default AircraftIcon;
